import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app/app';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './stores/store';
import { BrowserRouter } from 'react-router-dom';
import { ToastProvider } from './components/toast/toastProvider';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);


root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
      <ToastProvider>
        <App />
      </ToastProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();